import styled from "styled-components"

interface Sondeo {
  selected: number
}

export const ContainerMenu = styled.div`
  padding-left: 25px;
  height: 100%;
  display: flex;
  flex-direction: row;
`;

export const SubMenu = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

export const TitleMenu = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 5px;
`;


interface Props  {
  selected: any
}
export const ListMenu = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  div {
    padding: 10px 20px 10px 30px;
    font-size: 1.6rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    p {
      margin: 0;
      padding: 0;
    }


    div{
      padding: 10px 20px 10px 30px;
      font-size: 1.6rem;
      display:flex;
      flex-direction:row;
      justify-content:space-between;
      align-items:center;


      p{
        margin:0;
        padding:0;
      }
      
      :nth-child(${(p:Sondeo) => p.selected}){
        span{
          color: #C32105;
        }    
      }
      
      
    
      :hover {
        background-color: #F09999;
        border-radius: 7px 0px 0px 7px;
      }
    }

    :hover {
      background-color: #f09999;
      border-radius: 7px 0px 0px 7px;
    }
  }
`;

export const ImgCity = styled.img.attrs(() => ({
  src: process.env.PUBLIC_URL + "/city-club.png",
  alt: "city-club",
}))`
  width: 300px;
  opacity: 0.1;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  bottom: 100px;
`;

// export const ImgCity = styled.div`
//     background-image: url(${process.env.PUBLIC_URL}/city-club.png);
// `;
